export default [
  {
    path: 'request-letters',
    name: 'request-letters',
    component: () => import('@/views/pages/request-letters/RequestLetters.vue'),
    meta: {
      pageTitle: 'So‘rovlar',
      breadcrumb: [
        {
          text: 'So‘rovlar',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
  {
    path: 'request-letters/:id',
    name: 'request-letters-view',
    component: () => import('@/views/pages/request-letters/View.vue'),
    meta: {
      pageTitle: 'So‘rov',
      breadcrumb: [
        {
          to: { name: 'request-letters' },
          text: 'So‘rovlar',
          active: false,
        },
        {
          text: 'So‘rov',
          active: true,
        },
      ],
      resource: 'Letter',
    },
  },
]
